import PropTypes from 'prop-types';
import BaseFilter from './baseFilter.jsx';
import {DateFilter} from './dateFilter.jsx';

class SimpleFilter extends BaseFilter {
  loadAvailableOptions(defaults) {
    super.loadAvailableOptions(defaults);

    const options = {}
    this.props.options.forEach((option) => {
      options[option] = {
        title: option.titleize()
      }
    })

    return options;
  }
}

SimpleFilter.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  filterKey: PropTypes.string.isRequired,
  emptySelectedString: PropTypes.string.isRequired,
  filterIcon: PropTypes.string,
}

class EnumFilter extends BaseFilter {
  componentDidMount() {
    // Do not fire `filterInitialized`
  }

  loadAvailableOptions(defaults) {
    const url = `/api/api/common/v1/enums/${this.props.enumName}?countryCode=all`
    $.ajax({
      url,
      dataType: "JSON",
      type: "GET"
    }).done((data, textStatus) => {
      const availableOptions = {};
      const availableOptionKeys = [];

      for (let e of data.data) {
        if (!e.disabled) {
          availableOptions[e.value] = {
            title: e.name,
            selected: defaults.indexOf(e.value) !== -1
          }
          availableOptionKeys.push(e.value);
        }
      }

      const state = {
        availableOptions,
        availableOptionKeys
      }
      this.setState(state)

      radio("filterInitialized").broadcast(this);
    })
  }
}

EnumFilter.propTypes = {
  enumName: PropTypes.string.isRequired,
  filterKey: PropTypes.string.isRequired,
  emptySelectedString: PropTypes.string.isRequired,
  filterIcon: PropTypes.string,
  defaults: PropTypes.arrayOf(PropTypes.string)
}

class PaymentMethodFilter extends BaseFilter {
  loadAvailableOptions() {
    return {
      "credit_card": {
        "icon": "credit-card",
        "title": "Card",
        "subtext": "Card transactions",
        "selected": false
      },
      "instant_eft": {
        "icon": "mail-box-1",
        "title": "Instant EFT",
        "subtext": "Instant EFT transactions",
        "selected": false
      },
      "buy_now_pay_later": {
        "icon": "satellite",
        "title": "Buy Now Pay Later",
        "subtext": "Buy Now Pay Later transactions",
        "selected": false
      },
      "cash": {
        "icon": "coins-pile",
        "title": "Cash",
        "subtext": "Cash transactions",
        "selected": false
      },
      "custom": {
        "icon": "star-1",
        "title": "Custom",
        "subtext": "Custom payment method transactions",
        "selected": false
      },
    }
  }
}

PaymentMethodFilter.defaultProps = {
  "emptySelectedString": "All Payment Methods",
  "filterKey": "paymentMethod",
  "defaults": ["credit_card","instant_eft", "buy_now_pay_later"],
  "filterIcon": "icon-hand-coin",
  "filterColumns": 2
}

class PaymentTypeFilter extends BaseFilter {
  loadAvailableOptions() {
    return {
      "charge": {
        "icon": "credit-card",
        "title": "Charge",
        "selected": false
      },
      "refund": {
        "icon": "refresh",
        "title": "Refund",
        "selected": false
      },
      "adjustment": {
        "icon": "wrench",
        "title": "Adjustment",
        "selected": false
      },
    }
  }
}

PaymentTypeFilter.defaultProps = {
  "emptySelectedString": "All Types",
  "filterKey": "paymentType",
  "filterIcon": "icon-tag",
  "filterColumns": 2
}

class TransactionStateFilter extends BaseFilter {
  loadAvailableOptions() {
    return {
      "approved": {
        "icon": "check-circle text-success",
        "title": "Approved",
        "subtext": "Approved transactions",
        "selected": false
      },
      "declined": {
        "icon": "alert-round text-warning",
        "title": "Declined",
        "subtext": "Declined transactions",
        "selected": false
      },
      "aborted":{
        "icon": "minus-3 text-danger",
        "title": "Aborted",
        "subtext": "Aborted transactions",
        "selected": false
      },
      "error": {
        "icon": "alert text-danger",
        "title": "Error",
        "subtext": "Error transactions",
        "selected": false
      },
    }
  }
}

TransactionStateFilter.defaultProps = {
  "emptySelectedString": "All States",
  "filterKey": "transactionState",
  "defaults": ["approved"],
  "filterIcon": "icon-information"
}

class BusinessLifeCycleStateFilter extends BaseFilter {
  loadAvailableOptions() {
    return {
      "account_created": {
        "title": "Signing up",
        "subtext": "Is in the signing up process",
        "selected": false
      },
      "bought_readers":{
        "title": "Has signed up",
        "subtext": "Business has bought readers",
        "selected": false
      },
      "has_transacted": {
        "title": "Transacting",
        "subtext": "Business is transacting",
        "selected": false
      },
      "vetting_failed": {
        "title": "Vetting failed",
        "subtext": "Business failed the verification process",
        "selected": false
      },
      "account_closed": {
        "title": "Account closed",
        "subtext": "Business's account is closed",
        "selected": false
      },
    }
  }
}

BusinessLifeCycleStateFilter.defaultProps = {
  "emptySelectedString": "All Stages",
  "filterKey": "lifeCycleStage",
  "filterIcon": "icon-streamline-sync"
}

class BusinessCityFilter extends BaseFilter {
  loadAvailableOptions() {
    return {
      "Cape Town": {
        "title": "Cape Town",
        "selected": false
      },
      "Johannesburg":{
        "title": "Johannesburg",
        "selected": false
      },
      "Durban": {
        "title": "Durban",
        "selected": false
      }
    }
  }
}

BusinessCityFilter.defaultProps = {
  "emptySelectedString": "All Cities",
  "filterKey": "city",
  "filterIcon": "icon-map-pin-streamline"
}

class ApiFilter extends BaseFilter {
  componentDidMount() {
    this.isFirstLoad = true;
    //must override the filterInitialized radio call.
  }

  api() {
    return this.props.api;
  }

  loadAvailableOptions(defaults) {
    var loading = null;
    if (this.refs.dropdown) {
      loading = Utils.loading($(this.refs.dropdown))
    }
    var offset = 5 * this.pageNumber;
    var url = this.api() + "?pageSize=5&offset=" + offset;
    if (this.props.additionalParameters) {
      url = url + "&" + this.props.additionalParameters;
    }
    if (this.state.searchString) {
      url = url + "&search=" + this.state.searchString;
    }
    if (this.state.defaults) {
      url = url + "&included=" + encodeURIComponent(JSON.stringify(this.state.defaults));
    }

    this.requestIndex += 1
    var index = this.requestIndex

    $.ajax({
      url: url,
      dataType: "json",
      type: "GET"
    }).done((data, textStatus) => {
      if (loading) {
        loading.remove();
      }
      if (index == this.requestIndex) {
        if (data.status > 299) {
          this.showError(data.message);
        } else {
          var newKeys = [];
          var newOptions = {};
          if (offset > 0) {
            newKeys = this.state.availableOptionKeys;
            newOptions = this.state.availableOptions;
          } else {
            this.addSelected(newKeys, newOptions);
          }
          var list = [];

          if (this.props.defaultPath) {
            list = data.data[this.props.defaultPath];
          } else {
            var key = Object.keys(data.data)[0];
            if (key != "0") {
              list = data.data[key]
            }
            else {
              list = data.data
            }
          }

          for (var i = 0; i < list.length; i++) {
            var item = list[i];
            this.addDisplayableOption(item, newKeys, newOptions);
          }

          if (defaults) {
            var found = false;
            for (var key in newOptions) {
              if (defaults.indexOf(key) >= 0) {
                found = true;
                newOptions[key].selected = true;
              }
            }

            if (!found && defaults[0]) {
              var dummyItem = this.generateDummyItemFromParams(defaults[0]);
              if (dummyItem) {
                this.addDisplayableOption(
                  dummyItem,
                  newKeys,
                  newOptions);

                newOptions[defaults[0]].selected = true;
              }
            }
          }

          this.setState({
            "availableOptions": newOptions,
            "availableOptionKeys": newKeys,
            "showLoadMore": list.length == 5,
            "error": null
          });

          if (defaults) {
            radio("filterInitialized").broadcast(this);
          }

          if (offset > 0) {
            if (this.refs.dropdown) {
              $(this.refs.dropdown).toggle().toggle();
            }
          }
        }
      }
    }).fail((jqXHR, textStatus, errorThrown) => {
      if (index == this.requestIndex) {
        if (loading) {
          loading.remove();
        }
        this.showError(errorThrown);
      }
    })
  }

  showError(errorMessage) {
    console.log("Error in loading")
    console.log(errorMessage)
    this.setState({
      "error": errorMessage
    })
  }

  addDisplayableOption(option, newKeys, newOptions) {
    var optionKey = option.uuid;
    if (newKeys.indexOf(optionKey) == -1) {
      newKeys.push(optionKey);
      var subtext = option.email;
      if (option.info && option.info.staffNumber) {
        subtext = option.info.staffNumber;
      }
      newOptions[optionKey] = {
        "title": option.fullName,
        "subtext": subtext,
        "selected": false,
      }
    }
  }

  generateDummyItemFromParams(uuid) {
    return undefined;
  }

  addSelected(newKeys, newOptions) {
    for (var i = 0; i < this.state.availableOptionKeys.length; i++) {
      var key = this.state.availableOptionKeys[i];
      if (this.state.availableOptions[key].selected) {
        newKeys.push(key);
        newOptions[key] = this.state.availableOptions[key];
      }
    }
  }
}

ApiFilter.defaultProps = {
  "emptySelectedString": "Show all",
  "searchable": true,
  "placeholder": "Filter",
  "filterIcon": "icon-globe-2"
}

class BusinessApiFilter extends ApiFilter {
  addDisplayableOption(option, newKeys, newOptions) {
    var optionKey = option.uuid;
    if (!newKeys.indexOf(optionKey) >= 0) {
      newKeys.unshift(optionKey);
      newOptions[optionKey] = {
        "title": option.name,
        "subtext": option.owner.fullName,
        "selected": false,
      }
    }
  }

  generateDummyItemFromParams(uuid) {
    return {
      uuid: uuid,
      name: "Specified Business",
      owner: {fullName: uuid}
    }
  }
}

BusinessApiFilter.defaultProps = {
  "api": "/api/businesses/",
  "defaultPath": "businesses",
  "placeholder": "Filter businesses...",
  "emptySelectedString": "All Businesses",
  "filterKey": "businessUUID",
  "filterIcon": "icon-shop",
  "searchable": true
}

class UserApiFilter extends ApiFilter {
  api() {
    let api = "/api/users/";

    if (this.props.businessUUID) {
      api = "/api/businesses/{uuid}/users"
    }

    return api;
  }
}

UserApiFilter.defaultProps = {
  defaultPath: "users",
  placeholder: "Filter users...",
  additionalParameters: "excludeIntegrationStaff=false",
  filterKey: "userUUID",
  filterIcon: "icon-staff",
  emptySelectedString: "All Users",
  searchable: true
}

class PropertyFilter extends ApiFilter {
  addDisplayableOption(option, newKeys, newOptions) {
    var optionKey = option[0];
    if (newKeys.indexOf(optionKey) < 0) {
      newKeys.unshift(optionKey);
      newOptions[optionKey] = {
        "title": option[1],
        "subtext": option[2],
        "selected": false
      }
    }
  }
}

PropertyFilter.defaultProps = {
  "filterIcon": "icon-bookmark-1"
}

class ReaderModelFilter extends BaseFilter {
  loadAvailableOptions() {
    return {
      "P5": {
        "title": "Yoco Khumo",
        "selected": false
      },
      "N86": {
        "title": "Yoco Khumo Print",
        "selected": false
      },
      "P12": {
        "title": "Yoco Neo Touch",
        "selected": false
      },
      "BLUE_PAD55": {
        "title": "Yoco Neo",
        "selected": false
      },
      "QPOS_MINI": {
        "title": "Yoco Go",
        "selected": false
      },
      "M010": {
        "title": "Yoco Pro",
        "selected": false
      },
      "SHUTTLE": {
        "title": "Yoco Lite",
        "selected": false
      }
    }
  }
}

ReaderModelFilter.defaultProps = {
  "emptySelectedString": "All Readers",
  "filterKey": "model",
  "filterIcon": "icon-m10-6"
}

class PhoneTypeFilter extends BaseFilter {
  loadAvailableOptions() {
    return {
      "ios": {
        "title": "iOS",
        "icon": "apple",
        "selected": false
      },
      "android":{
        "title": "Android",
        "icon": "android",
        "selected": false
      },
      "windows":{
        "title": "Windows",
        "icon": "windows",
        "selected": false
      },
      "linux":{
        "title": "Linux",
        "icon": "linux",
        "selected": false
      },
      "macos":{
        "title": "MacOS",
        "icon": "apple",
        "selected": false
      }
    }
  }
}

PhoneTypeFilter.defaultProps = {
  "emptySelectedString": "All Device Types",
  "filterKey": "phoneType",
  "filterIcon": "icon-iphone-streamline"
}

class IntegrationFilter extends BaseFilter {
  loadAvailableOptions() {
    return {
      "standalone": {
        "title": "Standalone",
        "selected": false
      },
      "ikentoo-secret-uuid":{
        "title": "iKentoo TabletPOS",
        "selected": false
      }
    }
  }
}

IntegrationFilter.defaultProps = {
  "emptySelectedString": "All Software",
  "filterKey": "integratorSecretUUID",
  "filterIcon": "icon-box"
}

class CardTypeFilter extends BaseFilter {
  loadAvailableOptions() {
    return {
      "debit": {
        "title": "Debit",
        "selected": false
      },
      "credit":{
        "title": "Credit",
        "selected": false
      },
      "hybrid":{
        "title": "Hybrid",
        "selected": false
      }
    }
  }
}

CardTypeFilter.defaultProps = {
  "emptySelectedString": "All Card Types",
  "filterKey": "cardType",
  "filterIcon": "icon-credit-card"
}


class CardSchemeFilter extends BaseFilter {
  loadAvailableOptions() {
    return {
      "visa": {
        "title": "VISA",
        "selected": false,
        "icon": "visa-card"
      },
      "mastercard":{
        "title": "Mastercard",
        "selected": false,
        "icon": "master-card"
      }
    }
  }
}

CardSchemeFilter.defaultProps = {
  "emptySelectedString": "All Card Schemes",
  "filterKey": "cardScheme",
  "filterIcon": "icon-visa-card"
}

class PayoutDeductionStateFilter extends BaseFilter {
  loadAvailableOptions() {
    return {
      open: {
        title: "Open",
        subtext: "Loan is still open",
        selected: false,
        icon: "loop-1 text-info"
      },
      collections_on_hold: {
        title: "On hold",
        subtext: "Loan has been suspended",
        selected: false,
        icon: "clock text-warning"
      },
      collections_terminated: {
        title: "Terminated",
        subtext: "Loan has been terminated",
        selected: false,
        icon: "alert-round text-danger"
      },
      finished: {
        title: "Finished",
        subtext: "Loan has been successfully paid off",
        selected: false,
        icon: "check-circle text-success"
      }
    }
  }
}

PayoutDeductionStateFilter.defaultProps = {
  "emptySelectedString": "All States",
  "filterKey": "payoutDeductionState",
}


class PayoutDeductionCategoryFilter extends BaseFilter {
  loadAvailableOptions() {
    return {
      cash_advance: {
        title: "Cash advance",
        subtext: "Loan was given as cash",
        selected: false,
        icon: "coins-pile"
      },
      device_financing: {
        title: "Device financing",
        subtext: "Loan was given as a device",
        selected: false,
        icon: "iphone-streamline"
      },
      reader_financing: {
        title: "Reader financing",
        subtext: "Loan was given as a card reader",
        selected: false,
        icon: "cardreader"
      }
    }
  }
}

PayoutDeductionCategoryFilter.defaultProps = {
  "emptySelectedString": "All Categories",
  "filterKey": "payoutDeductionCategory",
}

class PayoutDeductionTypeFilter extends BaseFilter {
  loadAvailableOptions() {
    return {
      loan_plan: {
        title: "Loan plan",
        subtext: "The deduction plan for loans",
        selected: false,
        icon: "hand-coin"
      }
    }
  }
}

PayoutDeductionTypeFilter.defaultProps = {
  "emptySelectedString": "All Types",
  "filterKey": "payoutDeductionPlanType",
}

class PayoutStateFilter extends BaseFilter {
  loadAvailableOptions() {
    return {
      created: {
        title: "Created",
        selected: false
      },
      // withheld: {
      //   title: "Withheld",
      //   selected: false
      // }, // Withhelds are already automatically filtered out in Payouts
      submitted: {
        title: "Submitted",
        selected: false
      },
      accepted: {
        title: "Accepted",
        selected: false
      },
      rejected: {
        title: "Rejected",
        selected: false
      },
      unpaid: {
        title: "Unpaid",
        selected: false
      },
      paid: {
        title: "Paid",
        selected: false
      },
      paid_manually: {
        title: "Paid Manually",
        selected: false,
        enum_value: "paid-manually"
      },
      failed: {
        title: "Failed",
        selected: false
      },
      error: {
        title: "Error",
        selected: false
      },
      cancelled: {
        title: "Cancelled",
        selected: false
      }
    }
  }
}

PayoutStateFilter.defaultProps = {
  "emptySelectedString": "All Payout States",
  "filterKey": "state",
}

class ProcessingBankFilter extends BaseFilter {
  loadAvailableOptions() {
    return {
      mercantile: {
        title: "Mercantile",
        selected: false
      },
      absa: {
        title: "ABSA South Africa",
        selected: false
      }
    }
  }
}

ProcessingBankFilter.defaultProps = {
  "emptySelectedString": "All Processing Banks",
  "filterKey": "processingBank",
}

class ClientBusinessFilter extends BusinessApiFilter {

}

ClientBusinessFilter.defaultProps = Object.assign({}, BusinessApiFilter.defaultProps, {
  "placeholder": "Filter client business...",
  "emptySelectedString": "All client businesses",
  "filterKey": "clientBusinessUUID",
});

class MerchantBusinessFilter extends BusinessApiFilter {

}

MerchantBusinessFilter.defaultProps = Object.assign({}, BusinessApiFilter.defaultProps, {
  "placeholder": "Filter merchant business...",
  "emptySelectedString": "All merchant businesses",
  "filterKey": "merchantBusinessUUID",
});

class ProviderFilter extends ApiFilter {
  addDisplayableOption(option, newKeys, newOptions) {
    var optionKey = option.business.uuid;
    if (!newKeys.indexOf(optionKey) >= 0) {
      newKeys.unshift(optionKey);
      newOptions[optionKey] = {
        "title": option.business.name,
        "subtext": option.business.uuid,
        "selected": false,
      }
    }
  }
}

ProviderFilter.defaultProps = {
  "api": "/lending/providers/json",
  "defaultPath": "",
  "placeholder": "Filter provider...",
  "emptySelectedString": "All providers",
  "filterKey": "providerUUID",
  "filterIcon": "icon-shop",
  "searchable": false,
}

class ProviderBusinessFilter extends ProviderFilter {

}

ProviderBusinessFilter.defaultProps = Object.assign({}, ProviderFilter.defaultProps, {
  "filterKey": "providerBusinessUUID"
});

class CapitalOfferStateFilter extends ApiFilter {
  addDisplayableOption(option, newKeys, newOptions) {
    var optionKey = option.value;
    if (!newKeys.indexOf(optionKey) >= 0) {
      newKeys.unshift(optionKey);
      newOptions[optionKey] = {
        "title": option.name,
        "selected": false,
      }
    }
  }
}

CapitalOfferStateFilter.defaultProps = {
  "api": "/lending/offer_states/json",
  "defaultPath": "",
  "placeholder": "Filter offer state...",
  "emptySelectedString": "All states",
  "filterKey": "state",
  "searchable": false,
}

class PayoutAgeFilter extends BaseFilter {
  loadAvailableOptions() {
    return {
      true: {
        title: "Older than 15 minutes",
        selected: false
      }
    }
  }
}

PayoutAgeFilter.defaultProps = {
  "emptySelectedString": "Any age",
  "filterKey": "olderThanFifteenMinutes",
}

class DisputeStateFilter extends BaseFilter {
  loadAvailableOptions() {
    return {
      resolved: {
        title: "Resolved",
        selected: false,
      },
      chargeback: {
        title: "Chargeback",
        selected: false,
      },
      good_faith_refund: {
        title: "Good Faith Refund",
        selected: false,
      },
      in_dispute: {
        title: "In Dispute",
        selected: false,
      },
      cancelled: {
        title: "Cancelled",
        selected: false,
      }
    }
  }
}

DisputeStateFilter.defaultProps = {
  "emptySelectedString": "All Dispute States",
  "filterKey": "outcome",
}

class HasAdjustmentFilter extends BaseFilter{
  loadAvailableOptions() {
    return {
      true: {
        title: "true",
        selected: false
      },
      false: {
        title: "false",
        selected: false
      }
    }
  }
}

HasAdjustmentFilter.defaultProps = {
  "emptySelectedString": "Adjustment",
  "filterKey": "hasAdjustment",

}

class PayoutTypeFilter extends BaseFilter {
  loadAvailableOptions() {
    return {
      standard: {
        title: "Standard Payout",
        selected: false
      },
      instant: {
        title: "Instant Payout",
        selected: false
      }
    }
  }
}

PayoutTypeFilter.defaultProps = {
  "emptySelectedString": "All payout types",
  "filterKey": "payoutType"
}

module.exports = {
  BaseFilter: BaseFilter,
  SimpleFilter: SimpleFilter,
  EnumFilter: EnumFilter,
  DateFilter: DateFilter,
  PaymentMethodFilter,
  PaymentTypeFilter,
  TransactionStateFilter: TransactionStateFilter,
  BusinessLifeCycleStateFilter: BusinessLifeCycleStateFilter,
  ApiFilter: ApiFilter,
  BusinessApiFilter: BusinessApiFilter,
  UserApiFilter: UserApiFilter,
  BusinessCityFilter: BusinessCityFilter,
  ReaderModelFilter: ReaderModelFilter,
  IntegrationFilter: IntegrationFilter,
  PhoneTypeFilter: PhoneTypeFilter,
  CardTypeFilter: CardTypeFilter,
  CardSchemeFilter: CardSchemeFilter,
  PropertyFilter: PropertyFilter,
  PayoutDeductionStateFilter: PayoutDeductionStateFilter,
  ClientBusinessFilter: ClientBusinessFilter,
  MerchantBusinessFilter: MerchantBusinessFilter,
  ProviderBusinessFilter: ProviderBusinessFilter,
  ProviderFilter: ProviderFilter,
  PayoutDeductionCategoryFilter: PayoutDeductionCategoryFilter,
  PayoutDeductionTypeFilter: PayoutDeductionTypeFilter,
  ProcessingBankFilter: ProcessingBankFilter,
  PayoutStateFilter: PayoutStateFilter,
  CapitalOfferStateFilter: CapitalOfferStateFilter,
  PayoutAgeFilter: PayoutAgeFilter,
  DisputeStateFilter: DisputeStateFilter,
  HasAdjustmentFilter: HasAdjustmentFilter,
  PayoutTypeFilter: PayoutTypeFilter
}
